import { equals } from 'ramda';

import { DaysRange } from 'components/shared/DatePicker';

export const getFormattedDaysRange = (datesRange: DaysRange) => {
  if (!datesRange.from) return null;
  if (!datesRange.to || equals(datesRange.from, datesRange.to)) return `Day ${datesRange.from}`;

  return `Day ${datesRange.from} - ${datesRange.to}`;
};
